import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledCustomIcon = styled(SWReactIcons)`
    margin-right: 20px;
    svg {
        width: 24px;
        height: 24px;
    }
`;
export const StyledIcon = styled(SWReactIcons)`
    & svg > path {
        fill: ${colorsPalettes.blue[400]};
    }
    margin-right: 21px;
`;

export const StyledCsvBlock = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
`;

export const StyledEnrichedCsvWrapper = styled.div`
    border: 1px solid ${colorsPalettes.carbon[50]};
    margin-bottom: 8px;
    height: 72px;
    padding-left: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
`;

export const StyledCsvMainData = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
`;

export const StyledCsvMetaData = styled.div<{ width?: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid ${colorsPalettes.carbon[50]};
    padding: 0 20px;
    box-sizing: border-box;

    ${({ width }) => width && `width: ${width};`}

    &.noBorder {
        border: none;
    }
`;

export const StyledCsvName = styled.div`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin-bottom: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    max-width: 646px;
    @media (max-width: 1280px) {
        max-width: 570px;
    }
    @media (max-width: 1180px) {
        max-width: 500px;
    }
    @media (max-width: 1100px) {
        max-width: 350px;
    }
    @media (max-width: 950px) {
        max-width: 200px;
    }
`;

export const StyledCsvDate = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
`;

export const StyledCsvValue = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[400])}
`;

export const StyledCaption = styled.div`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height:14px;
    text-align: center;
`;

export const StyledDownload = styled(SWReactIcons)`
    & svg > path {
        fill: ${colorsPalettes.blue[400]};
    }
    cursor: pointer;
`;
